/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Toggle_ShowInputs */



/**
* | output |
* | --- |
* | "Show Subtitle Styling" |
*
* @param {Video_Export_Style_Toggle_ShowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_toggle_show = /** @type {((inputs?: Video_Export_Style_Toggle_ShowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Toggle_ShowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher le style des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelformatierung anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra stile sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать стиль субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar estilo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示字幕样式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕スタイルを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक शैली दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exibir estilo de legenda")
	return /** @type {LocalizedString} */ ("Show Subtitle Styling")
});